import React from 'react';
import { COLORS, getTonalColors } from '../../utils/calendar/constants';
import { useTheme } from '../../contexts/ThemeContext';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ value, onChange }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className="grid grid-cols-6 gap-1.5">
      {COLORS.map((c) => {
        const tonal = getTonalColors(c.bg);
        const bg = isDark ? tonal.bgDark : tonal.bgLight;
        const text = isDark ? tonal.textDark : tonal.textLight;
        const isSelected = c.bg === value;

        return (
          <button
            key={c.bg}
            type="button"
            onClick={() => onChange(c.bg)}
            title={c.name}
            style={{ backgroundColor: bg }}
            className={`w-6 h-6 rounded-full flex items-center justify-center mx-auto transition-transform text-[11px] font-light leading-none ${
              isSelected
                ? 'ring-1 ring-offset-1 ring-[var(--accent-primary)] ring-offset-[var(--surface-elevated)] scale-110'
                : 'hover:scale-110'
            }`}
          >
            <span style={{ color: text }}>A</span>
          </button>
        );
      })}
    </div>
  );
};
